import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Title} from "@angular/platform-browser";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {environment} from "../../../environments/environment";
import {InstitutionControllerService} from "../../services/institution-controller/institution-controller.service";
import {Store} from "../../services/store.service";
import {BaseError} from "../pages/base-error";
import {AuthService} from "../../services/auth/auth-service";
import {SystemProperties} from "../../models/system-properties";
import {SystemPropertiesControllerService} from "../../services/system-settings/system-properties-controller.service";

@Component({
  selector: "app-wrapper",
  templateUrl: "./wrapper.component.html",
  styleUrls: ["./wrapper.component.css"],
})
export class WrapperComponent extends BaseError implements OnInit, OnDestroy {
  @Input() public wrapperCssClass: string;
  @Input() public reloadServices = false;
  @Input() public isLoginPage = false;
  @Input() public hideServices = false;
  @Input() public hideSidenav = true;
  @Input() public loadHeader = true;
  @Input() public systemProperties: any = { value: new SystemProperties()};

  public isUserDefined = false;
  public userId: string = "";
  public userName: string = "";
  public userEmail: string = "";
  public userInitial: string = "";
  public user: any;
  public tokenChangeSubscriber: any;

  constructor(private router: Router,
              public store: Store,
              private title: Title,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef,
              private institutionControllerService: InstitutionControllerService,
              private systemPropertiesControllerService: SystemPropertiesControllerService,
              private authService: AuthService,
              public toastr: ToastrService) {
    super(toastr);
    this.logout = this.logout.bind(this);
  }

  public async ngOnInit() {
    if (!this.isLoginPage) {
        this.route.params.subscribe((params) => {
            this.store.state.common.serviceId = (params.serviceId === "new") ? undefined : params.serviceId;
        });
        await this.recompute();
        if (!Boolean(environment.KEYCLOAK_ACTIVE)) {
          this.tokenChangeSubscriber = this.setupAccess.bind(this);
          this.authService.subscribeForTokenChange(this.tokenChangeSubscriber);
        }
    }
    if (this.router.url !== "/catalogues" && this.router.url !== "/translate") {
      this.setTitle();
      this.loadSystemProperties();
    }
    window.addEventListener("message", async (event) => {
      if (event.source !== window) {
        return;
      }
      if (event.data.type === "GET_JWT_FOR_AI_EXTENSION") {
        const loggedIn = await this.authService.isLoggedIn();
        if (!loggedIn) {
          return;
        }
        const jwt = await this.authService.getToken();
        window.postMessage({
          type: "JWT_RESPONSE",
          jwt
        }, "*");
      }
    });
  }

  public setTitle() {
    if (environment.APP_TITLE) {
      let newTitle = environment.APP_TITLE;
      if (this.systemProperties && this.systemProperties.siteName) {
        newTitle = this.systemProperties.siteName;
      }
      if (this.router.url.indexOf("/") !== -1) {
        const url = this.router.url.split("/");
        if (url.length > 1) {
          const pos = url[url.length - 1].length > 30 ? url.length - 2 : url.length - 1;
          const page = url[pos].charAt(0).toUpperCase() + url[pos].slice(1);
          newTitle = newTitle + " - " + ( page ? page.replace("-", " ") : "Services");
        }
      }
      newTitle = newTitle.split(";")[0];
      this.title.setTitle(newTitle);
    } else {
      this.title.setTitle("BPA");
    }
  }

  public loadSystemProperties() {
    this.systemPropertiesControllerService.getServiceProperties().subscribe(
        (systemProperties) => {
          if (systemProperties) {
            this.systemProperties = systemProperties;
            this.setTitle();
          }
        },
    );
  }

  public async setupAccess() {
    await this.recompute();
    const data = await this.authService.getUserInfo();
    // @ts-ignore
    if (data && data.roles) {
      // @ts-ignore
      const isAllowedToAccess = data.roles.indexOf(AuthService.neededRole) > -1;
      if (!isAllowedToAccess) { return await this.logout("bpa.no.rights"); }
    } else {
      console.error("PARTC is down, do not know what to do.");
    }
  }

  public ngOnDestroy() {
    this.authService.unsubscribeForTokenChange(this.tokenChangeSubscriber);
  }

  public async logout(error: string = "") {
      let redirectUri = window.location.origin + "/login";
      if (error) { redirectUri += "?error=" + error; }
      return await this.authService.logout(redirectUri);
  }

  private async recompute() {
    const savedTokenValid = await this.authService.isLoggedIn();
    if (savedTokenValid && this.authService.isUserInRole()) {
      // user logged in and has needed role
      this.userId = await this.authService.getUserId();
      this.userName = await this.authService.getUsername();
      this.userEmail = await this.authService.getUserEmail();
      this.user = await this.authService.getUserInfo();
      this.userInitial = `${(this.user?.firstName?.charAt(0) || this.user?.username?.charAt(0)) || this.user?.properties[0]?.values[0]?.value?.charAt(0)}${(this.user?.lastName?.charAt(0) || this.user?.username?.charAt(1)) || this.user?.properties[1]?.values[0]?.value?.charAt(0)}`;
      this.isUserDefined = true;
      return Promise.resolve();
    }
    return await this.logout(this.authService.isUserInRole() ? "" : "bpa.no.rights");
  }
}
